import React from "react";
import { Wrapper, Content, Pic, AbtMe } from "./AboutMeHero.styles";

import ME from "../../images/me-rv.png";

const AboutMeHero = () => (
  <Wrapper>
    <Content>
      <h1>About Me</h1>
      <section>
        <Pic src={ME} alt='Again, this is me lol' />
        <AbtMe>
          <h1>Hi, I’m Mohamed.</h1>
          <p className="justified">
            I'm an independent software developer and IT engineer based in
            Algeria. I love creating beautiful looking websites, and consistent
            software for the benefit of the best user experience possible. And I
            consider myself to be completly blessed that i get to do it for a
            living.
          </p>
          <p className="justified">
            I have a master degree in Network and Data Engineering. I develope
            software since 2017. I started my coding career back then with
            purpos of continuously learning and developing my skills in software
            development, communication and marketing.
          </p>
        </AbtMe>
      </section>
    </Content>
  </Wrapper>
);

export default AboutMeHero;
